<template>
  <div
    v-if="agentEnabled"
    class="search-ai-wrapper"
  >
    <SearchAi
      v-model:open-ak-drawer="isDrawerOpen"
      :search-query="searchQuery"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { SearchAi } from '@ankorstore/search-ai';
import store from '@client/monolith/legacy/store';
import { useAgent } from '../composables/use-agent/use-agent';

const { agentEnabled } = useAgent();
const searchQuery = ref(null);
const isDrawerOpen = ref(false);

store.subscribeAction({
  after: (action) => {
    if (action.type === 'searchBar/initAiSearchAction') {
      if (action.payload.search === '') {
        isDrawerOpen.value = true;
      } else {
        searchQuery.value = action.payload.search;
        isDrawerOpen.value = true;
      }
    }
  },
});

const clearSearchQuery = () => {
  searchQuery.value = null;
};

watch(isDrawerOpen, (newVal) => {
  if (!newVal) {
    clearSearchQuery();
  }
});
</script>

<style lang="scss" scoped>
.search-ai-wrapper {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  width: 0;
  height: 0;
  overflow: hidden;
}
</style>
